import get from "lodash.get";
import { HeroVariant } from "../../../core/types";
import { ProviderData } from "../../../lib/appContext/types";

const landingFormVariants = new Array<HeroVariant>();

export const inVariant = (
  businessUnitConfig: ProviderData["businessUnitConfig"],
  variants: HeroVariant[]
): boolean => {
  const widgetVariant = get(businessUnitConfig, "widgets.hero.variant");
  return variants.indexOf(widgetVariant) !== -1;
};

export const hasForm = ({
  businessUnitConfig: { businessUnit, businessCode }
}: ProviderData): boolean =>
  ["car-insurance", "travel-insurance"].indexOf(businessUnit) !== -1 &&
  businessCode !== "travel-insurance-ar";

export const isLandingForm = ({ businessUnitConfig }: ProviderData): boolean => {
  return inVariant(businessUnitConfig, landingFormVariants);
};
